module.exports = {
  endpoints: {
	itemService: window.location.origin,
	pathPrefix: 'pa/api/v1/',
  },
  availablePdfNames: [
    "manageteamsdlcprocess.pdf",
    "pgssdlcprocess.pdf",
    "plt20sdlcprocess.pdf"
  ]
};
